// @flow
import React, { useState } from 'react';
import classnames from 'classnames';

import ratios from 'Components/utils/ratios/ratios.utils';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import Image from 'Components/frameworks/image/Image.jsx';

type Props = {
  className?: string,
  description: string,
  imageSrc: string,
  seeMoreLabel?: string,
  title: string,
  trackingData?: TrackingData,
};

export function ProductMustTryCard(props: Props) {
  const { className, description, imageSrc, seeMoreLabel, title, trackingData } = props;

  const [isExpanded, setExpanded] = useState(false);

  return (
    <TrackClick
      as="button"
      className={classnames(
        className,
        'reset-button overflow-hidden relative text-initial w-full h-full',
      )}
      data-testid="ProductMustTryCard"
      onClick={() => setExpanded(!isExpanded)}
      trackingData={trackingData}
    >
      <div className="relative h-full pb-12">
        <div className="bg-gray-darker rounded-tiny overflow-hidden image-responsive-cell">
          <Image
            altMsg=""
            groupKey="thumbnails"
            hasLazyLoading
            imageUrl={imageSrc}
            ratioKey={ratios.R_38_BY_28}
          />
        </div>
        <p
          className="reset-paragraph px-4 pt-4 text-center text-md leading-tight overflow-hidden"
          style={{ maxHeight: '55px' }}
        >
          {title}
        </p>
        {!!seeMoreLabel && (
          <p className="reset-paragraph my-4 text-center text-sm underline absolute bottom-0 inset-x-0">
            {seeMoreLabel}
          </p>
        )}
        <div
          className={classnames(
            'absolute top-full bg-white max-h-full overflow-y-auto mt-1 mx-1 pt-5 px-5 pb-1 rounded-tiny text-center transition-transform',
            {
              '-translate-y-100': isExpanded,
              'translate-y-0': !isExpanded,
            },
          )}
        >
          <p className="reset-paragraph mb-5 text-lg">{title}</p>
          <p className="reset-paragraph text-base">{description}</p>
        </div>
      </div>
    </TrackClick>
  );
}
